import { Facebook, Google } from "@/assets";
import { API_ENDPOINT } from "@/constants/appConstants";
import { useRegistrationProps } from "@/context/useRegistrationProps";
import { useNetwork } from "@/hooks/useNetwork";
import useSocialLogin from "@/hooks/useSocialLogin";
import { UserProfile } from "@/types/userDetails";
import { getQueryParams } from "@/utils/util";
import { Pill } from "@monsterindia/global-ui-components";
import React, { useEffect } from "react";

type SocilaLoginProps = {
  handleAfterSocialLogin: (user: UserProfile) => void;
};

type ValidateResponse = {
  data: {
    validationStatus?: string;
    accessToken?: string;
    message?: string;
  };
  error?: string;
  isloading?: boolean;
};

const SocialLogin: React.FC<SocilaLoginProps> = ({
  handleAfterSocialLogin,
}) => {
  const { hostname } = useRegistrationProps();
  const { fetchData: fetchAPI } = useNetwork();
  const { socialUser, handleSocialLogin } = useSocialLogin();
  const isFacebookVisible = false;

  const doAutoLogin = async (data: any) => {
    const clientId =
      getQueryParams()["client_id"] ?? "fd111af2-493d-11e8-9621-24a074f06450";

    let reqData = {
      username: data.socialAccessToken,
      social_provider: data.socialProvider,
      grant_type: "password",
      scope: "all",
      client_id: clientId,
    };
    try {
      const resp = await fetchAPI(
        API_ENDPOINT(hostname).middleware.doAutoLogin,
        "POST",
        {},
        reqData,
      );
      const returnURL = getQueryParams()["return_url"];
      if (resp && resp.data) {
        window.location.href = returnURL ?? "/seeker/dashboard";
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (socialUser && !socialUser.error) {
        let reqData = {
          socialProvider: socialUser.provider,
          socialAccessToken: socialUser.accessToken,
        };
        try {
          const resp = (await fetchAPI(
            API_ENDPOINT(hostname).middleware.validateSocial,
            "POST",
            {},
            reqData,
          )) as ValidateResponse;
          if (resp && resp.data && resp.data.validationStatus) {
            const { validationStatus } = resp.data;
            if (validationStatus === "USER_EXISTS") {
              // auto login
              await doAutoLogin(reqData);
            } else {
              if (socialUser) {
                handleAfterSocialLogin(socialUser);
              }
            }
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    };
    fetchData();
  }, [socialUser]);
  return (
    <>
      <div className="social-pills flex gap-2">
        <Pill
          id="google"
          size="medium"
          displayName="Google"
          leftIcon={<Google />}
          onClickFunctionHandler={() => handleSocialLogin("google")}
          customClass="justify-center"
        />
        {isFacebookVisible && (
          <Pill
            id="facebook"
            size="medium"
            displayName="Facebook"
            leftIcon={<Facebook />}
            onClickFunctionHandler={() => handleSocialLogin("facebook")}
            customClass="justify-center"
          />
        )}
      </div>
      <div className="border-gray-05 relative border">
        <span className="text-content-placeholder absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform bg-white px-2 text-xs">
          OR
        </span>
      </div>
    </>
  );
};

export default SocialLogin;
